import { render, staticRenderFns } from "./products.page.vue?vue&type=template&id=50c2cdb0&scoped=true&"
import script from "./products.page.vue?vue&type=script&lang=js&"
export * from "./products.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c2cdb0",
  null
  
)

export default component.exports